import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CasePartOne from './CasePartOne';
import {
  SpecimenView,
  WithRole,
  CaseLevel,
} from '../components';
import { buildCaseFormId, buildSpecimenFormId } from '../helpers/formIdCreator';
import { checkIfASpecimenIsSelected } from '../redux/reducers';
import { CASE_PART_ONE, CASE_PART_TWO, userRoles } from '../constants';
import Printer from '../helpers/Printer';

const CaseContent = ({ casePartSelected, aSpecimenIsSelected, formId }) => {
  const componentToDisplay = (role, selectedCasePart) => {
    if (role === userRoles.val_pathologist) {
      return <SpecimenView role={role} key={formId} />;
    }

    if (selectedCasePart === CASE_PART_ONE) {
      return <CasePartOne role={role} />;
    }

    if (selectedCasePart === CASE_PART_TWO) {
      if (aSpecimenIsSelected) {
        return <SpecimenView role={role} key={formId} />;
      }

      if (!aSpecimenIsSelected) {
        return <CaseLevel role={role} key={formId} />;
      }
    }
  };

  return (
    <WithRole
      render={role => <Printer>{componentToDisplay(role, casePartSelected)}</Printer>}
    />
  );
};

const mapStateToProps = (state) => {
  const { casePartSelected, selectedCase, currentPathologist, selectedSpecimen } = state._case;
  const aSpecimenIsSelected = checkIfASpecimenIsSelected(state);
  const formId = aSpecimenIsSelected
    ? buildSpecimenFormId(selectedSpecimen, currentPathologist)
    : buildCaseFormId(selectedCase, currentPathologist);
  return {
    casePartSelected,
    formId,
    aSpecimenIsSelected,
  };
};


export default connect(mapStateToProps)(CaseContent);
